import React from 'react'
import { Link } from 'react-router-dom'

export default () =>
  <div className='nothing'>
    <h1>No content</h1>
    <p>
      Use the <Link to={`${document.location.pathname}/new`} className='btn'>Add New</Link> button to create content.
    </p>
  </div>



// WEBPACK FOOTER //
// ./app/components/help/NoContent.js